module.exports = {
          srcSet: __webpack_public_path__ + "public/e72b968d3d507cddfcd7fa012ca19f19-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/e72b968d3d507cddfcd7fa012ca19f19-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/e72b968d3d507cddfcd7fa012ca19f19-80.png",
          toString:function(){return __webpack_public_path__ + "public/e72b968d3d507cddfcd7fa012ca19f19-80.png"},
          
          width: 80,
          height: 80
        }